export type ThresholdStatus = "good" | "warn" | "bad" | "unknown";

interface ThresholdBarProps {
  status: ThresholdStatus;
  markerPct: number | null;
}

export function ThresholdBar({ status, markerPct }: ThresholdBarProps) {
  const clamped = markerPct === null ? 0 : Math.min(100, Math.max(0, markerPct));
  return (
    <div className="relative h-1.5 w-full overflow-hidden rounded-full bg-surface-raised/60">
      <div
        className="absolute inset-y-0 left-0 w-1/3 bg-success/80"
        aria-hidden="true"
      />
      <div
        className="absolute inset-y-0 left-1/3 w-1/3 bg-warning/80"
        aria-hidden="true"
      />
      <div
        className="absolute inset-y-0 right-0 w-1/3 bg-danger/80"
        aria-hidden="true"
      />
      {markerPct !== null && (
        <div
          className="absolute top-1/2 -mt-2 h-4 w-0.5 rounded-sm bg-threshold-marker shadow-[0_0_0_2px_rgba(255,255,255,0.9)] dark:shadow-[0_0_0_2px_rgba(0,0,0,0.6)]"
          style={{ left: `${clamped}%` }}
          aria-label={`${status} (${clamped.toFixed(0)}% of range)`}
        />
      )}
    </div>
  );
}
